import { useEffect, useState } from 'react';
import { endOfDay } from './day';

/**
 * Re-renders when the app comes back to the foreground and when a new learning day starts
 * (04:00), so a phone left open overnight shows today's plan, not yesterday's.
 */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const refresh = () => setNow(new Date());
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    let timer = 0;
    const schedule = () => {
      const ms = endOfDay(new Date()).getTime() - Date.now() + 1000;
      timer = window.setTimeout(() => {
        refresh();
        schedule();
      }, Math.min(Math.max(ms, 1000), 2 ** 31 - 1));
    };
    schedule();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', refresh);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  return now;
}
